const common = {
  // Nav
  nav_home: 'Início',
  nav_books: 'Livros',
  nav_courses: 'Cursos',
  nav_mentorship: 'Mentoria SÍLEX',
  nav_webinars: 'Webinars',
  nav_about: 'Sobre',
  nav_contact: 'Contato',
  nav_links: 'Links',
  nav_enter: 'Entrar',
  nav_my_courses: 'Meus Cursos',
  nav_community: 'Comunidade',
  nav_ranking: 'Ranking',
  nav_certificates: 'Certificados',
  // Auth
  auth_login_title: 'Acesse sua conta',
  auth_login_subtitle: 'Entre com e-mail ou redes sociais',
  auth_register_title: 'Criar sua conta',
  auth_register_subtitle: 'Cadastre-se para acessar os cursos',
  auth_forgot_title: 'Recuperar senha',
  auth_forgot_subtitle: 'Enviaremos um link para seu e-mail',
  auth_tab_login: 'Entrar',
  auth_tab_register: 'Criar Conta',
  auth_email: 'E-mail',
  auth_password: 'Senha',
  auth_name: 'Nome completo',
  auth_confirm_password: 'Confirmar senha',
  auth_forgot_link: 'Esqueci minha senha',
  auth_btn_login: 'Entrar com E-mail',
  auth_btn_register: 'Criar Conta Grátis',
  auth_btn_forgot: 'Enviar Link de Recuperação',
  auth_or: 'ou continue com',
  auth_or_register: 'ou cadastre-se com',
  auth_google: 'Continuar com Google',
  auth_facebook: 'Continuar com Facebook',
  auth_apple: 'Continuar com Apple',
  auth_back_login: '← Voltar para o login',
  auth_terms: 'Ao entrar, você concorda com nossos',
  auth_terms_link: 'Termos de Uso',
  auth_privacy_link: 'Política de Privacidade',
  auth_and: 'e',
  // Livros page
  livros_hero_badge: 'Biblioteca Completa',
  livros_hero_title: 'Ebooks & Livros',
  livros_hero_subtitle: 'Conhecimento que transforma. Escolha seu próximo livro e comece sua jornada de evolução.',
  livros_filter_all: 'Todos',
  livros_filter_pdf: 'E-book PDF',
  livros_filter_print: 'Impresso',
  livros_search_placeholder: 'Buscar livro ou tema...',
  livros_btn_buy: 'Comprar Agora',
  livros_btn_amazon: 'Amazon',
  livros_btn_details: 'Ver Detalhes',
  livros_pages: 'págs',
  livros_readers: 'leitores',
  livros_cta_title: 'Quer acesso a todos os livros?',
  livros_cta_subtitle: 'Assine a SB Family e tenha acesso ilimitado a todo o acervo + cursos + mentoria em grupo.',
  livros_cta_btn: 'Conhecer a Assinatura',
  livros_stat_books: 'Livros Publicados',
  livros_stat_readers: 'Leitores Satisfeitos',
  livros_stat_rating: 'Avaliação Média',
  livros_stat_editions: 'Edições Revisadas',
  // Language
  lang_label: 'Idioma',
  lang_pt: 'Português',
  lang_es: 'Español',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_it: 'Italiano',
  lang_ja: '日本語',
};

export default common;
